var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisksSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2352_24405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1369 40.2802V40.3272C40.1118 41.0296 39.5249 41.6104 38.7776 41.6104H11.4571C10.694 41.6104 10.0969 41.0028 10.0969 40.2802V2.75085C10.0969 2.02776 10.6938 1.42065 11.4571 1.42065H38.7767C39.5403 1.42065 40.1369 2.02803 40.1369 2.75085V40.2802Z",
    fill: "white",
    stroke: "#044D9F",
    strokeWidth: 2.02979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 10.6467C37.5478 11.054 37.217 11.384 36.8097 11.384H13.1795C12.7722 11.384 12.4414 11.054 12.4414 10.6467C12.4414 10.2394 12.7722 9.90771 13.1795 9.90771H36.8097C37.217 9.90771 37.5478 10.2394 37.5478 10.6467Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 14.5241C37.5478 14.9314 37.217 15.2631 36.8097 15.2631H13.1795C12.7722 15.2631 12.4414 14.9314 12.4414 14.5241C12.4414 14.1168 12.7722 13.7852 13.1795 13.7852H36.8097C37.217 13.7843 37.5478 14.116 37.5478 14.5241Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 6.76903C37.5478 7.17634 37.217 7.508 36.8097 7.508H13.1795C12.7722 7.508 12.4414 7.17634 12.4414 6.76903C12.4414 6.36172 12.7722 6.03174 13.1795 6.03174H36.8097C37.217 6.03153 37.5478 6.36151 37.5478 6.76903Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 18.3999C37.5478 18.8089 37.217 19.1389 36.8097 19.1389H13.1795C12.7722 19.1389 12.4414 18.8089 12.4414 18.3999C12.4414 17.9926 12.7722 17.6626 13.1795 17.6626H36.8097C37.217 17.6618 37.5478 17.9917 37.5478 18.3999Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 22.0925C37.5478 22.4998 37.217 22.8314 36.8097 22.8314H13.1795C12.7722 22.8314 12.4414 22.4998 12.4414 22.0925C12.4414 21.6852 12.7722 21.3535 13.1795 21.3535H36.8097C37.217 21.3535 37.5478 21.6852 37.5478 22.0925Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5478 25.9687C37.5478 26.376 37.217 26.7077 36.8097 26.7077H13.1795C12.7722 26.7077 12.4414 26.376 12.4414 25.9687C12.4414 25.5614 12.7722 25.2314 13.1795 25.2314H36.8097C37.217 25.2314 37.5478 25.5614 37.5478 25.9687Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.383 50.0005V50.0485C43.3577 50.7714 42.7621 51.3533 42.0237 51.3533H14.7032C13.9492 51.3533 13.343 50.7447 13.343 50.0005V12.1103C13.343 11.3656 13.9491 10.7576 14.7032 10.7576H42.0228C42.7772 10.7576 43.383 11.3659 43.383 12.1103V50.0005Z",
    fill: "white",
    stroke: "#044D9F",
    strokeWidth: 2.02979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 20.135C41.0676 20.5423 40.7367 20.8723 40.3294 20.8723H16.6991C16.2918 20.8723 15.9609 20.5423 15.9609 20.135C15.9609 19.7277 16.2918 19.396 16.6991 19.396H40.3292C40.7367 19.396 41.0676 19.7277 41.0676 20.135Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 24.0124C41.0676 24.4197 40.7367 24.7514 40.3294 24.7514H16.6991C16.2918 24.7514 15.9609 24.4197 15.9609 24.0124C15.9609 23.6051 16.2918 23.2734 16.6991 23.2734H40.3292C40.7367 23.2726 41.0676 23.6043 41.0676 24.0124Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 16.2573C41.0676 16.6646 40.7367 16.9963 40.3294 16.9963H16.6991C16.2918 16.9963 15.9609 16.6646 15.9609 16.2573C15.9609 15.85 16.2918 15.52 16.6991 15.52H40.3292C40.7367 15.5198 41.0676 15.8498 41.0676 16.2573Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 27.8882C41.0676 28.2972 40.7367 28.6271 40.3294 28.6271H16.6991C16.2918 28.6271 15.9609 28.2972 15.9609 27.8882C15.9609 27.4809 16.2918 27.1509 16.6991 27.1509H40.3292C40.7367 27.1498 41.0676 27.48 41.0676 27.8882Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 31.5808C41.0676 31.9881 40.7367 32.3197 40.3294 32.3197H16.6991C16.2918 32.3197 15.9609 31.9881 15.9609 31.5808C15.9609 31.1735 16.2918 30.8418 16.6991 30.8418H40.3292C40.7367 30.8418 41.0676 31.1735 41.0676 31.5808Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0676 35.4575C41.0676 35.8648 40.7367 36.1965 40.3294 36.1965H16.6991C16.2918 36.1965 15.9609 35.8648 15.9609 35.4575C15.9609 35.0502 16.2918 34.7202 16.6991 34.7202H40.3292C40.7367 34.7194 41.0676 35.0494 41.0676 35.4575Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0353 58.5259V58.5739C47.01 59.2967 46.4145 59.8787 45.676 59.8787H18.3555C17.6016 59.8787 16.9954 59.2701 16.9954 58.5259V20.6357C16.9954 19.891 17.6014 19.283 18.3555 19.283H45.6752C46.4296 19.283 47.0353 19.8913 47.0353 20.6357V58.5259Z",
    fill: "white",
    stroke: "#044D9F",
    strokeWidth: 2.02979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7403 26.3146C44.7403 26.722 44.4094 27.0519 44.0021 27.0519H20.3718C19.9645 27.0519 19.6328 26.722 19.6328 26.3146C19.6328 25.9073 19.9645 25.5757 20.3718 25.5757H44.0019C44.4103 25.5751 44.7403 25.9065 44.7403 26.3146Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7403 30.1911C44.7403 30.5984 44.4094 30.9301 44.0021 30.9301H20.3718C19.9645 30.9301 19.6328 30.5984 19.6328 30.1911C19.6328 29.7838 19.9645 29.4521 20.3718 29.4521H44.0019C44.4103 29.4515 44.7403 29.783 44.7403 30.1911Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7403 33.8815C44.7403 34.2889 44.4094 34.6205 44.0021 34.6205H20.3718C19.9645 34.6205 19.6328 34.2889 19.6328 33.8815C19.6328 33.4742 19.9645 33.144 20.3718 33.144H44.0019C44.4103 33.1443 44.7403 33.4742 44.7403 33.8815Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7403 37.7595C44.7403 38.1668 44.4094 38.497 44.0021 38.497H20.3718C19.9645 38.497 19.6328 38.167 19.6328 37.7595C19.6328 37.3522 19.9645 37.0205 20.3718 37.0205H44.0019C44.4103 37.0205 44.7403 37.352 44.7403 37.7595Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7417 40.8984H20.3718C19.9645 40.8984 19.6328 41.2284 19.6328 41.6357C19.6328 42.043 19.9645 42.3747 20.3718 42.3747H32.7409C33.1482 42.3747 33.479 42.043 33.479 41.6357C33.4792 41.2284 33.1492 40.8984 32.7417 40.8984Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.2287,
    cy: 48.9181,
    r: 7.91616,
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2352_24405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1975 51.5059L47.0734 44.3643C46.9399 44.1331 46.6932 43.9907 46.4262 43.9907C46.1592 43.9907 45.9125 44.1331 45.779 44.3643L41.6549 51.5059C41.5213 51.7371 41.5213 52.0221 41.6548 52.2533C41.7883 52.4846 42.0351 52.627 42.3021 52.627H50.5503C50.8173 52.627 51.0641 52.4846 51.1976 52.2533C51.3311 52.0221 51.3311 51.7371 51.1975 51.5059ZM42.3021 51.8797L46.4262 44.7381L50.5503 51.8797H42.3021Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9083 47.3112L46.1226 49.7649C46.1351 49.9094 46.2497 50.0284 46.3991 50.0415C46.5665 50.0561 46.714 49.9323 46.7286 49.7649L46.943 47.3112C46.9453 47.2825 46.9456 47.2504 46.943 47.2208C46.918 46.935 46.6662 46.7237 46.3804 46.7486C46.0947 46.7736 45.8833 47.0255 45.9083 47.3112Z",
    fill: "#F7A010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4248 51.0507C46.6615 51.0507 46.8534 50.8588 46.8534 50.622C46.8534 50.3853 46.6615 50.1934 46.4248 50.1934C46.188 50.1934 45.9961 50.3853 45.9961 50.622C45.9961 50.8588 46.188 51.0507 46.4248 51.0507Z",
    fill: "#F7A010"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2352_24405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.8936,
    height: 60.8936,
    fill: "white",
    transform: "translate(0.554688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2352_24405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.74297,
    height: 9.74297,
    fill: "white",
    transform: "translate(41.5586 43.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisksSmall);
export default __webpack_public_path__ + "static/media/risksSmall.6e96b17c5bba49ee6d16aa0e9fe19484.svg";
export { ForwardRef as ReactComponent };